import {SidebarPageLayout} from '@github-ui/layout-primitives/SidebarPageLayout'
import {Link} from '@github-ui/react-router'
import {useRepoIssuesSidebarLayoutEnabled} from '@github-ui/repo-issues-page-layout/useSidebarLayoutEnabled'
import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {Button, Heading} from '@primer/react'

import {LABELS} from './constants/labels'
import type {RepositoryResult} from './repository-milestone-index-page-query-types'
import styles from './RepositoryMilestone.module.css'

// RELAY-CLEANUP(RepositoryMilestoneIndexPageContentInternal): widens nullable fields so the still-Relay parent
// data is assignable. Remove when RepositoryMilestoneIndexPageContentInternal leaves Relay.
export type MilestonesActionsFragment = RelayCompat<Pick<RepositoryResult, 'viewerCanPush' | 'nameWithOwner'>>

type MilestonesActionsProps = {
  repository: MilestonesActionsFragment
}

export function MilestonesActions({repository: {viewerCanPush, nameWithOwner}}: MilestonesActionsProps) {
  const newMilestoneUrl = `/${nameWithOwner}/milestones/new`

  if (useRepoIssuesSidebarLayoutEnabled()) {
    return null
  }

  return (
    <div className={styles.buttonGrp}>
      <div className={styles.titleGroup}>
        <SidebarPageLayout.SidebarTrigger />
        <Heading as="h1" className={styles.heading}>
          Milestones
        </Heading>
      </div>

      {viewerCanPush ? (
        <div className={styles.actionsGrp}>
          {/* Link hard-navigates to hand off to the Data Router app when /milestones/new
              isn't registered here (flag on); soft-navigates otherwise. */}
          <Button as={Link} to={newMilestoneUrl} variant="primary" data-testid="new-milestone-button">
            {LABELS.newMilestone}
          </Button>
        </div>
      ) : null}
    </div>
  )
}
